module.exports = __webpack_public_path__ + "static/media/SAND.2bad2ca7.png";